import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';

import {
  ChoiceBlock,
  ChoiceOption
} from '@core/services/ai/ai-assistant.service';

@Component({
  selector: 'app-ai-choice-block',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule],
  template: `
    <div class="block">
      <p class="block__prompt">{{ block.prompt }}</p>
      <div class="block__choices">
        @for (c of block.choices; track c.id) {
          <button
            type="button"
            mat-stroked-button
            class="block__choice"
            (click)="onChoice(c)">
            <span class="block__choice-label">{{ c.label }}</span>
            @if (c.description) {
              <span class="block__choice-desc">{{ c.description }}</span>
            }
          </button>
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .block {
        background: #fff;
        border: 1px solid rgba(15, 23, 42, 0.08);
        border-radius: 12px;
        padding: 12px 14px;
      }
      .block__prompt {
        margin: 0 0 10px;
        font-size: 14px;
        color: rgba(15, 23, 42, 0.85);
        line-height: 1.45;
      }
      .block__choices {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      .block__choice {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        text-align: left !important;
        padding: 8px 12px !important;
        line-height: 1.3 !important;
        height: auto !important;
      }
      .block__choice-label {
        font-weight: 600;
        font-size: 13px;
      }
      .block__choice-desc {
        font-size: 12px;
        color: rgba(15, 23, 42, 0.55);
        margin-top: 2px;
      }
    `
  ]
})
export class AiChoiceBlockComponent {
  @Input({ required: true }) block!: ChoiceBlock;
  /** Emitted when the user picks a choice. The host turns it into a follow-up message. */
  @Output() readonly choiceSelected = new EventEmitter<ChoiceOption>();

  onChoice(choice: ChoiceOption): void {
    this.choiceSelected.emit(choice);
  }
}
